export const ERROR_TITLE = "Oops…something went wrong!";
export const ERROR_SUBTITLE =
  "Check to see if you are connected to a network right now or try reloading.";
export const RELOAD = "Reload";
export const SEARCH_AGAIN = "Search Again";

export const UPDATE_USER_PASSENGER = "packagesBook/UPDATE_USER_PASSENGER";
export type UPDATE_USER_PASSENGER = typeof UPDATE_USER_PASSENGER;

export const SET_USER_PASSENGERS = "packagesBook/SET_USER_PASSENGERS";
export type SET_USER_PASSENGERS = typeof SET_USER_PASSENGERS;

export const DELETE_USER_PASSENGER = "packagesBook/DELETE_USER_PASSENGER";
export type DELETE_USER_PASSENGER = typeof DELETE_USER_PASSENGER;

export const FETCH_USER_PASSENGERS = "packagesBook/FETCH_USER_PASSENGERS";
export type FETCH_USER_PASSENGERS = typeof FETCH_USER_PASSENGERS;

export const SET_USER_PASSENGERS_CALL_STATE =
  "packagesBook/SET_USER_PASSENGERS_CALL_STATE";
export type SET_USER_PASSENGERS_CALL_STATE =
  typeof SET_USER_PASSENGERS_CALL_STATE;

export const FETCH_CORP_USER_PASSENGERS =
  "packagesBook/FETCH_CORP_USER_PASSENGERS";
export type FETCH_CORP_USER_PASSENGERS =
  typeof FETCH_CORP_USER_PASSENGERS;